module.exports = __webpack_public_path__ + "static/media/APP_NightWatch_152x174_1.6c5fb618.png";